<template>
  <div class="brand-content">
    <img
      v-if="logoUrl"
      :src="logoUrl"
      class="brand-content__logo"
      :class="bigLogo ? 'big-logo' : 'normal'"
      alt="Brand logo" />
    <logo-icon
      v-else
      class="brand-content__logo"
      :class="bigLogo ? 'big-logo' : 'normal'" />
    <span
      v-if="location"
      class="brand-content__location">
      {{ location }}
    </span>
    <span
      v-if="secondLocation"
      class="brand-content__second-location">
      {{ secondLocation }}
    </span>
    <img
      v-if="!logoUrl && secondaryLogoUrl"
      :src="secondaryLogoUrl"
      class="brand-content__secondary-logo"
      alt="Brand logo" />
  </div>
</template>

<script setup>
  import LogoIcon from '~/assets/svgs/logo.svg'

  defineProps({
    location: {
      type: String,
      required: true
    },
    secondLocation: {
      type: String,
      default: null
    },
    bigLogo: {
      type: Boolean,
      default: false
    },
    logoUrl: {
      type: String,
      default: null
    },
    secondaryLogoUrl: {
      type: String,
      default: null
    }
  })
</script>

<style lang="scss" scoped>
.brand-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-ss);

  &__logo {
    width: 300px;
    height: auto;
    color: var(--color-red);

    @include up-to-tablet {
      width: 150px;
    }

    &.big-logo {
      width: 430px;
      max-height: 250px;
      object-fit: contain;
      object-position: center;

      @include up-to-tablet {
        width: 100%;
      }
    }
  }

  &__secondary-logo {
    max-width: 200px;
    height: auto;
    object-fit: contain;
  }

  &__location {
    font-family: var(--font-family-poppins);
    font-size: 30px;
    font-weight: var(--font-weight-bold);
    color: var(--color-red);

    // text-transform: uppercase;

    @include up-to-tablet {
      font-size: var(--typography-size-ui-kit-16);
    }
  }

  &__second-location {
    font-family: var(--font-family-poppins);
    font-size: 30px;
    font-weight: var(--font-weight-medium);
    color: var(--color-red);
    text-align: center;
    margin-top: rem(16px);

    @include up-to-tablet {
      font-size: var(--typography-size-ui-kit-16);
      margin-top: rem(8px);
    }
  }
}
</style>
